export interface ITerminalUpdateOrRemoveDto {
    terminalId: string;
    username: string;
}

export class TerminalUpdateOrRemoveRequest {
    public terminalId: string;
    public username: string;

    constructor(terminalId: string, username: string){
        this.terminalId = terminalId;
        this.username = username;
    }
}